export class Environment {
  production: boolean;
  statistics: boolean;
  appVersion = '1.3.0';
  apiHost: string;
  sentryDsn: string | null = null;
  whatsappNumber = '551740046655';

  constructor(options: {
    production: boolean;
    statistics: boolean;
    apiHost: string
    sentryDsn?: string;
  }) {
    this.production = options.production;
    this.statistics = options.statistics;
    this.apiHost = options.apiHost;

    if (options.sentryDsn) {
      this.sentryDsn = options.sentryDsn;
    }
  }
}
